import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from './app-config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class CruisepciService {
  OBPortalSvcURL = '';

  constructor(
    private appConfigService: AppConfigService,
    private httpClient: HttpClient
  ) {}

  public GetCruisePCI(eventCode: string | undefined): Observable<any> {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    const CruisePCIInfo: JSON = <JSON>(<unknown>{
      eventCode: eventCode,
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<any>(
      this.OBPortalSvcURL + 'GetCruisePCI',
      JSON.stringify(CruisePCIInfo),
      { headers: headers }
    );
  }
}
